<script lang="ts" setup>
import type { IbexaRichTextField } from '@@/types/Ibexa'
import type { ImageAspectRatio } from '@@/types/Image'

import ImageCaption from '@/components/common/ImageCaption.vue'

defineProps<{
  src: string
  altText: string
  caption?: IbexaRichTextField
  copyright?: string
  aspectRatio?: ImageAspectRatio // Update type ImageAspectRatio to add more options as needed.
  objectFit?: 'contain' | 'cover' // | 'fill' | 'none' | 'scale-down'
}>()
</script>

<template>
  <div
    v-if="!!src"
    :class="['image-with-caption-container', objectFit, aspectRatio && `image-with-caption-container-${aspectRatio}`]"
  >
    <img
      class="image"
      :style="{ objectFit }"
      :src="src"
      :alt="altText"
    >
    <slot name="imageCaption">
      <ImageCaption
        :caption="caption?.xhtml5output"
        :copyright="copyright"
        class="image-caption"
      />
    </slot>
  </div>
</template>

<style scoped lang="scss">
  .image-with-caption-container {
    position: relative;
    overflow: hidden;
    display: flex;
    aspect-ratio: v-bind('aspectRatio');
  }

  .image {
    width: 100%;
    object-fit: contain;
  }

  .image-caption {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
  }
</style>
